import { DataSourcesQueries } from '@frontend/api-data-sources';
import { ScheduleFFHelpers } from '@frontend/schedule-helpers';

export const useGetWaitlistFeatureFlagDetails = () => {
  const directSchedulingFFInfo = ScheduleFFHelpers.useWaitlistDirectSchedulingFeatureFlag();

  const { isIntegratedOffice, isLoading: isLoadingIntegrationDetails } =
    DataSourcesQueries.useGetAccessibleIntegrations();

  const isLoading = directSchedulingFFInfo.isLoading || isLoadingIntegrationDetails;

  const isWaitlistDirectBookingEnabled = directSchedulingFFInfo.isEnabled && !isIntegratedOffice;

  return {
    isLoading,

    isWaitlistDirectBookingEnabled,
  };
};
